import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AccountResourceService } from '../../../shared/services/account-resource.service';
import { ApiConfig } from '../../../shared/services/api/config.api';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class UserlockService {
  constructor(public httpClient: HttpClient, private accountResourceService: AccountResourceService) {
  }

  getUser(empId, certNo, pNum, pSize) {
    return this.httpClient.get(ApiConfig.baseURL + 'api/admin/userunlock/page?employeeId=' + empId + '&certNo=' + certNo + '&page=' + pNum + '&size=' + pSize);
  }

  unlockUser(userId): Observable<any> {
    return this.accountResourceService.unlock(userId);
  }
}
